import { useEffect, useState } from "react";

const useScrolled = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      try {
        if (window.scrollY > 20) {
          setHasScrolled(true);
        } else {
          setHasScrolled(false);
        }
      } catch (error) {
        console.error(error);
        setHasScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return hasScrolled;
};

export default useScrolled;
